export enum ReturnType {
  NONE = "NONE",
  MAINTENANCE_RETURN = "MAINTENANCE_RETURN",
  SALES_RETURN = "SALES_RETURN",
  CAMPAIGN_RETURN = "CAMPAIGN_RETURN",
}
